import AspectController from './aspectController';
import './aspect.scss';

const AspectComponent = {
    template: require('./aspectView.html'),
    controller: AspectController,
};

AspectController.$inject = [
    'StepLearningEngagementService',
    'EvaluationService',
    'UserService',
    '$q',
    '$stateParams',
    '$state',
    '$mdDialog',
    '$mdToast',
];

export default AspectComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/pages/aspectComponent.js